export const config = {
  appName: '排播系統',
} as const
